/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { StockLabel } from ".";

import NotFoundIcon from "../icons/image-not-found.svg";
import { useState } from "react";

const StyledProductCard = styled.div`
  padding: 1em;
  width: 180px;
  height: 320px;
  @media (min-width: 381px) and (max-width: 420px) {
    font-size: 14px;
  }
  margin-left: -30px;
  .main-container {
    border: 2px solid #efefef;
    border-radius: 8px;
    &_sales {
      background-color: #efefef;
      text-align: center;
      text-transform: uppercase;
      text-align: center;
    }
    &_sales p {
      margin: 0;
      padding: 10px 0;
    }
    &_image {
      width: 100%;
      padding: 10px;
    }
  }
`;

const ProductCard = ({ product }: any) => {
  const [imageURL, setimageURL] = useState(
    "https://desa-pharmacys.avatar-global.com/wcsstore/DF_CatalogAsset/" +
      product.productReport.fullimage
  );

  return (
    <Grid item sm={6} md={3}>
      <StyledProductCard>
        <div className="main-container">
          <div className="main-container_sales">
            <p>{Math.round(product.quantitySold)} Vendidos</p>
          </div>
          <div
            className="main-container_image"
            style={{
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}>
            <img
              src={imageURL}
              alt="icono"
              style={{ width: "100%" }}
              onError={() => {
                setimageURL(NotFoundIcon);
              }}
            />
          </div>
        </div>
        <p className="product_name">{product.productReport.name}</p>
        <StockLabel stock={product.productReport.stock} />
      </StyledProductCard>
    </Grid>
  );
};

export default ProductCard;
